<div *ngIf="data.length > 0; else noData" echarts [options]="options" [merge]="options" class="d-flex w-100 h-100"></div>

<ng-template #noData>
    <span class="d-flex m-auto mat-h3">No data retrieved!</span>
</ng-template>
